import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// LanguageSwitcher déplacé dans le Footer (PR feat/landing-scroll-anims-footer-lang)
// pour désencombrer la top-bar et regrouper les contrôles secondaires en bas de page.
import './AuroraNavbar.css';

/**
 * Navbar aurora partagée. Classes scopées `.an-*` (aucune dépendance à landingCss).
 * Prop `activeLink` : 'how' | 'pricing' | 'blog' — souligne l'onglet courant.
 */
export default function AuroraNavbar({ activeLink = '' }) {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const goHome = (hash) => {
    setMenuOpen(false);
    navigate(hash ? `/${hash}` : '/');
  };
  const goRegister = () => { setMenuOpen(false); navigate('/register'); };
  const goLogin = () => { setMenuOpen(false); navigate('/login'); };

  const isActive = (key) => activeLink === key ? ' an-active' : '';

  return (
    <>
      <nav className={'an-nav' + (scrolled ? ' an-scrolled' : '')}>
        <div className="an-nav-inner">
          <Link to="/" className="an-logo" aria-label={t('nav.home_aria')}>
            <div className="an-logo-mark">R</div>
            <span>Revyo</span>
          </Link>

          <div className="an-nav-pill">
            <button className={'an-pill-item' + isActive('how')} onClick={() => goHome('#how')}>{t('nav.how_it_works')}</button>
            <button className={'an-pill-item' + isActive('pricing')} onClick={() => goHome('#pricing')}>{t('nav.pricing')}</button>
            <Link to="/blog" className={'an-pill-item' + isActive('blog')}>{t('nav.blog')}</Link>
          </div>

          <div className="an-nav-cta">
            <button
              className={'an-mobile-trigger' + (menuOpen ? ' open' : '')}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label={t('nav.menu')}
            >
              <span /><span /><span />
            </button>
            <button className="an-btn-ghost" onClick={goLogin}>{t('nav.login')}</button>
            <button className="an-btn-primary" onClick={goRegister}>{t('nav.free_trial')}</button>
          </div>
        </div>
      </nav>

      <div className={'an-mobile-menu' + (menuOpen ? ' open' : '')}>
        <button className="an-mm-link" onClick={() => goHome('#how')}>{t('nav.how_it_works')}<span>→</span></button>
        <button className="an-mm-link" onClick={() => goHome('#pricing')}>{t('nav.pricing')}<span>→</span></button>
        <Link to="/blog" className="an-mm-link" onClick={() => setMenuOpen(false)}>{t('nav.blog')}<span>→</span></Link>
        <button className="an-mm-link" onClick={goLogin}>{t('nav.login')}<span>→</span></button>
        <button className="an-mm-cta" onClick={goRegister}>{t('nav.free_trial')} →</button>
      </div>
    </>
  );
}
